export default __webpack_public_path__ + "static/media/ian_harris.1aa5c3ce.jpg";